"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeClass = exports.styleTypeClass = exports.closeButtonClass = exports.animationTypeClass = exports.WithContainer = exports.MODAL_TYPE = exports.MODAL_STYLE_TYPE = exports.MODAL_CLOSE_BUTTON = exports.MODAL_ANIMATION_TYPE = exports.MODAL_ANIMATION_DURATION = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
var _Modal = require("../Modal");
var _scrollLock = require("../utils/scrollLock");
var _excluded = ["onCloseModal", "onOpenModal", "onKeyDown"];
var _animationTypeClass, _closeButtonClass, _styleTypeClass, _typeClass;
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var MODAL_ANIMATION_TYPE = /*#__PURE__*/function (MODAL_ANIMATION_TYPE) {
  MODAL_ANIMATION_TYPE["fade"] = "fade";
  MODAL_ANIMATION_TYPE["none"] = "none";
  MODAL_ANIMATION_TYPE["slideLeft"] = "slideLeft";
  MODAL_ANIMATION_TYPE["slideRight"] = "slideRight";
  return MODAL_ANIMATION_TYPE;
}({});
exports.MODAL_ANIMATION_TYPE = MODAL_ANIMATION_TYPE;
var MODAL_CLOSE_BUTTON = /*#__PURE__*/function (MODAL_CLOSE_BUTTON) {
  MODAL_CLOSE_BUTTON["left"] = "left";
  MODAL_CLOSE_BUTTON["none"] = "none";
  MODAL_CLOSE_BUTTON["right"] = "right";
  return MODAL_CLOSE_BUTTON;
}({});
exports.MODAL_CLOSE_BUTTON = MODAL_CLOSE_BUTTON;
var MODAL_STYLE_TYPE = /*#__PURE__*/function (MODAL_STYLE_TYPE) {
  MODAL_STYLE_TYPE["default"] = "default";
  MODAL_STYLE_TYPE["transparent"] = "transparent";
  return MODAL_STYLE_TYPE;
}({});
exports.MODAL_STYLE_TYPE = MODAL_STYLE_TYPE;
var MODAL_TYPE = /*#__PURE__*/function (MODAL_TYPE) {
  MODAL_TYPE["default"] = "default";
  MODAL_TYPE["fullscreen"] = "fullscreen";
  MODAL_TYPE["leftSide"] = "leftSide";
  MODAL_TYPE["onBoarding"] = "onBoarding";
  MODAL_TYPE["rightSide"] = "rightSide";
  MODAL_TYPE["small"] = "small";
  return MODAL_TYPE;
}({});
exports.MODAL_TYPE = MODAL_TYPE;
var animationTypeClass = (_animationTypeClass = {}, (0, _defineProperty2["default"])(_animationTypeClass, MODAL_ANIMATION_TYPE.none, ''), (0, _defineProperty2["default"])(_animationTypeClass, MODAL_ANIMATION_TYPE.fade, 'cds-Modal-Animation--Fade'), (0, _defineProperty2["default"])(_animationTypeClass, MODAL_ANIMATION_TYPE.slideLeft, 'cds-Modal-Animation--SlideLeft'), (0, _defineProperty2["default"])(_animationTypeClass, MODAL_ANIMATION_TYPE.slideRight, 'cds-Modal-Animation--SlideRight'), _animationTypeClass);
exports.animationTypeClass = animationTypeClass;
var closeButtonClass = (_closeButtonClass = {}, (0, _defineProperty2["default"])(_closeButtonClass, MODAL_CLOSE_BUTTON.none, 'cds-Modal-CloseButton--Hidden'), (0, _defineProperty2["default"])(_closeButtonClass, MODAL_CLOSE_BUTTON.right, 'cds-Modal-CloseButton--Right'), (0, _defineProperty2["default"])(_closeButtonClass, MODAL_CLOSE_BUTTON.left, 'cds-Modal-CloseButton--Left'), _closeButtonClass);
exports.closeButtonClass = closeButtonClass;
var styleTypeClass = (_styleTypeClass = {}, (0, _defineProperty2["default"])(_styleTypeClass, MODAL_STYLE_TYPE["default"], ''), (0, _defineProperty2["default"])(_styleTypeClass, MODAL_STYLE_TYPE.transparent, 'cds-Modal-StyleType--Transparent'), _styleTypeClass);
exports.styleTypeClass = styleTypeClass;
var typeClass = (_typeClass = {}, (0, _defineProperty2["default"])(_typeClass, MODAL_TYPE["default"], ''), (0, _defineProperty2["default"])(_typeClass, MODAL_TYPE.fullscreen, 'cds-Modal-Type--Fullscreen'), (0, _defineProperty2["default"])(_typeClass, MODAL_TYPE.leftSide, 'cds-Modal-Type--LeftSide'), (0, _defineProperty2["default"])(_typeClass, MODAL_TYPE.rightSide, 'cds-Modal-Type--RightSide'), (0, _defineProperty2["default"])(_typeClass, MODAL_TYPE.small, 'cds-Modal-Type--Small'), (0, _defineProperty2["default"])(_typeClass, MODAL_TYPE.onBoarding, 'cds-Modal-Type--OnBoarding'), _typeClass);

//it should be the same as $cds-Modal-Animation-Duration in Modal.scss
exports.typeClass = typeClass;
var MODAL_ANIMATION_DURATION = 250;
exports.MODAL_ANIMATION_DURATION = MODAL_ANIMATION_DURATION;
var WithContainer = function WithContainer(props) {
  var onCloseModal = props.onCloseModal,
    onOpenModal = props.onOpenModal,
    onKeyDown = props.onKeyDown,
    originalProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _props$animationType = props.animationType,
    animationType = _props$animationType === void 0 ? MODAL_ANIMATION_TYPE.none : _props$animationType,
    isOpen = props.isOpen,
    isDefaultOpen = props.isDefaultOpen;
  var animationDuration = animationType === MODAL_ANIMATION_TYPE.none ? 0 : MODAL_ANIMATION_DURATION;
  var modalRef = (0, _react.useRef)(null);
  var closeButtonRef = (0, _react.useRef)(null);
  var firstUpdate = (0, _react.useRef)(true);
  var onOpenChange = (0, _react.useCallback)(function (isOpen) {
    isOpen ? onOpenModal === null || onOpenModal === void 0 ? void 0 : onOpenModal() : onCloseModal === null || onCloseModal === void 0 ? void 0 : onCloseModal();
  }, [onOpenModal, onCloseModal]);
  var _useControlledState = (0, _reactUseControlledState["default"])(isDefaultOpen, isOpen, onOpenChange),
    _useControlledState2 = (0, _slicedToArray2["default"])(_useControlledState, 2),
    isStateOpen = _useControlledState2[0],
    setIsStateOpen = _useControlledState2[1];
  var handleCloseModal = (0, _react.useCallback)(function () {
    (0, _scrollLock.removeScrollLock)();
  }, []);
  var handleOpenModal = (0, _react.useCallback)(function () {
    (0, _scrollLock.addScrollLock)();
    setTimeout(function () {
      var _closeButtonRef$curre;
      return (_closeButtonRef$curre = closeButtonRef.current) === null || _closeButtonRef$curre === void 0 ? void 0 : _closeButtonRef$curre.focus();
    });
  }, [closeButtonRef]);
  (0, _react.useEffect)(function () {
    if (!isStateOpen && !firstUpdate.current) {
      handleCloseModal();
    }
    if (firstUpdate.current) {
      firstUpdate.current = false;
    }
    if (isStateOpen) {
      handleOpenModal();
      return handleCloseModal;
    }
  }, [isStateOpen, handleOpenModal, handleCloseModal]);
  var handleKeyDown = (0, _react.useCallback)(function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      setIsStateOpen(false);
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event.key);
  }, [setIsStateOpen, onKeyDown]);
  var handleClickAway = (0, _react.useCallback)(function (event) {
    var _modalRef$current;
    if ((_modalRef$current = modalRef.current) !== null && _modalRef$current !== void 0 && _modalRef$current.contains(event.target)) {
      return;
    }
    setIsStateOpen(false);
  }, [modalRef, setIsStateOpen]);
  var handleClose = (0, _react.useCallback)(function (event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    setIsStateOpen(false);
  }, [setIsStateOpen]);
  var handleOpen = (0, _react.useCallback)(function (event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    setIsStateOpen(true);
  }, [setIsStateOpen]);
  var injectedProps = {
    animationDuration: animationDuration,
    closeButtonRef: closeButtonRef,
    isOpen: isStateOpen,
    modalRef: modalRef,
    onClickAway: handleClickAway,
    onClose: handleClose,
    onKeyDown: handleKeyDown,
    onOpen: handleOpen
  };
  return /*#__PURE__*/_react["default"].createElement(_Modal.Modal, (0, _extends2["default"])({}, originalProps, injectedProps));
};
exports.WithContainer = WithContainer;